import useTranslation from '../utils/useTranslation';
import { SOCIALS } from '../data/socials';

export default function Footer() {
  const { t, lang } = useTranslation();
  const year = new Date().getFullYear();
  const brandName = lang === 'ar' ? t('brand_title_ar') : t('brand_title_en');

  return (
    <footer className="footer">
      <div className="container footer-grid">
        <div className="footer-col footer-about">
          <div className="footer-brand">
            <span className="footer-brand-name">{t('brand_title_ar')}</span>
          </div>
          <p className="footer-tagline">{t('footer_tagline')}</p>
        </div>

        <div className="footer-col">
          <h4 className="footer-heading">{t('footer_contact')}</h4>
          <ul className="footer-contact">
            <li className="footer-contact-row">
              <span className="footer-contact-ico" aria-hidden="true">
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.7" strokeLinecap="round" strokeLinejoin="round">
                  <path d="M20 10c0 6-8 12-8 12s-8-6-8-12a8 8 0 0 1 16 0z" />
                  <circle cx="12" cy="10" r="3" />
                </svg>
              </span>
              <span>{t('contact_address_value')}</span>
            </li>
            <li>
              <a
                className="footer-contact-row footer-contact-row--link"
                href={`tel:${t('contact_phone_value').replace(/[\s-]/g, '')}`}
              >
                <span className="footer-contact-ico" aria-hidden="true">
                  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.7" strokeLinecap="round" strokeLinejoin="round">
                    <path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72c.13.96.36 1.9.7 2.81a2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45c.91.34 1.85.57 2.81.7A2 2 0 0 1 22 16.92z" />
                  </svg>
                </span>
                <span dir="ltr">{t('contact_phone_value')}</span>
              </a>
            </li>
            <li>
              <a className="footer-contact-row footer-contact-row--link" href={`mailto:${t('contact_email_value')}`}>
                <span className="footer-contact-ico" aria-hidden="true">
                  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.7" strokeLinecap="round" strokeLinejoin="round">
                    <rect x="3" y="5" width="18" height="14" rx="2" />
                    <path d="m3 7 9 6 9-6" />
                  </svg>
                </span>
                <span>{t('contact_email_value')}</span>
              </a>
            </li>
          </ul>
        </div>

        <div className="footer-col">
          <h4 className="footer-heading">{t('footer_follow')}</h4>
          <p className="footer-follow-note">{t('footer_follow_note')}</p>
          <ul className="footer-socials">
            {SOCIALS.map((s) => (
              <li key={s.id}>
                <a
                  className="footer-social"
                  href={s.href}
                  target="_blank"
                  rel="noreferrer"
                  aria-label={s.label}
                  title={s.label}
                >
                  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.7" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
                    {s.icon}
                  </svg>
                </a>
              </li>
            ))}
          </ul>
        </div>
      </div>

      <div className="container footer-bottom">
        <span>
          {'\u00A9'} {year} {brandName}. {t('footer_rights')}
        </span>
      </div>
    </footer>
  );
}
